import AdvanceInitContainer from "../../../../Components/Tables/DataTables/AdvanceInit/AdvanceInit"

const AdvanceInit = () => {
  return (
    <div className='page-body'>
      <AdvanceInitContainer />
    </div>
  )
}

export default AdvanceInit